import http from '@/plugins/axios/axios';

export default class PontoService {
    
    espelho(requisicao, params) {       
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/ponto/espelho' + p, requisicao);
    }
    
    registrar(requisicao, params) {       
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/ponto/marcar' + p, requisicao);
    }

    incluirMarcacao(requisicao, params) {       
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/ponto/incluir-marcacao' + p, requisicao);
    }

    justificar(requisicao, params) {       
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/ponto/justificar' + p, requisicao);
    }

    marcacoes(requisicao, params) {       
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/ponto/marcacoes' + p, requisicao);
    }

    downloadMarcacaoPdf(requisicao, params) {
        let p = params ? '?' + params : '';
        return http.post('/api/v1/app/ponto/marcacoes/pdf' + p, requisicao, {responseType: 'blob'});
    }

    solicitacoes(requisicao, params) {   
        let p = params ? '?' + params : '';    
        return http.post('/api/v1/app/ponto/solicitacoes' + p, requisicao);
    } 

    solicitacoesPendentes(requisicao, params) {   
        let p = params ? '?' + params : '';    
        return http.post('/api/v1/app/ponto/solicitacoes-pendentes' + p, requisicao);
    } 
}